const Config = process.env;
export function sendFormApi(data) {
  const params = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  return fetch(Config.REACT_APP_FORM_ENDPOINT, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((error) => {
      return error;
    });
}

export function getProductsApi() {
  const params = {
    headers: {
      "Content-Type": "application/json",
      "X-API-KEY": Config.REACT_APP_PRODUCTS_ENDPOINT_TOKEN,
    },
  };

  return fetch(Config.REACT_APP_PRODUCTS_ENDPOINT, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((error) => {
      return error;
    });
}
